"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const utils_1 = require("data/transactions/utils");
const RegPayeeField_1 = __importDefault(require("./RegPayeeField"));
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const PayeeField = ({ attributes, forceStatic, callbacks, editable, SHOW_ALL, txn, wrapClass, editClass, hoverClass, bankPendingClass, currEditFieldName, enableAutoFocus, accountIds, focusField, }) => {
    const { classes } = useStyles();
    const c2RTxnClass = (0, utils_1.isC2RTransaction)(txn) ? classes.txnInC2RText : '';
    return (<styles_1.RegListItem {...attributes} className={(0, classnames_1.default)(classes.regItem, 'flex2', wrapClass, editClass, hoverClass, bankPendingClass, c2RTxnClass)}>
      {SHOW_ALL &&
            <RegPayeeField_1.default editable={editable && currEditFieldName === 'payee'} txn={txn} autoFocus={enableAutoFocus} forceStatic={forceStatic} 
            // @ts-expect-error: The expected type comes from property 'onChange' which is declared here on type 'IntrinsicAttributes & AmountFieldProps'
            onFocus={callbacks.handleFocus} 
            // @ts-expect-error:  The expected type comes from property 'onChange' which is declared here on type 'IntrinsicAttributes & RegPayeeFieldProps'
            onChange={(e, fieldName, rawValue) => callbacks.handleChange(e, fieldName || 'payee', rawValue)} inputRef={(input) => {
                    focusField.current = input; // eslint-disable-line
                }} accountIds={accountIds}/>}
    </styles_1.RegListItem>);
};
exports.default = PayeeField;
